module.exports = __webpack_public_path__ + "static/media/telcell.f376787d.png";